import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { WithdrawData } from "./WithdrawData";

const Withdraws = () => {
  document.title = "Users Withdraws | mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Users Withdraws" />
          <WithdrawData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Withdraws;
